
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface QuantityInputProps {
  quantity: string;
  setQuantity: (value: string) => void;
}

const QuantityInput = ({ quantity, setQuantity }: QuantityInputProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="quantity">Quantité</Label>
      <Input
        id="quantity"
        type="number"
        min="1"
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
      />
    </div>
  );
};

export default QuantityInput;
